var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlineBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 64,
    viewBox: "0 0 73 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.20598 1.92358C2.14535 1.92358 1.28223 2.78671 1.28223 3.84733V59.9214C1.28223 60.9827 2.14535 61.8452 3.20598 61.8452H69.2926C70.3532 61.8452 71.2163 60.9827 71.2163 59.9214V3.84733C71.2163 2.78671 70.3532 1.92358 69.2926 1.92358H3.20598ZM69.2928 63.1277H3.20625C1.43832 63.1277 0 61.6894 0 59.9215V3.84736C0 2.07944 1.43832 0.641113 3.20625 0.641113H69.2928C71.0601 0.641113 72.4991 2.07944 72.4991 3.84736V59.9215C72.4991 61.6894 71.0601 63.1277 69.2928 63.1277Z",
    fill: "#106C3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.641602 9.61893H71.8582V8.33643H0.641602V9.61893Z",
    fill: "#106C3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.64315 4.98791C5.64315 5.57786 5.16477 6.05687 4.57418 6.05687C3.98423 6.05687 3.50586 5.57786 3.50586 4.98791C3.50586 4.39796 3.98423 3.91895 4.57418 3.91895C5.16477 3.91895 5.64315 4.39796 5.64315 4.98791Z",
    fill: "#106C3A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.27596 4.98791C9.27596 5.57786 8.79759 6.05687 8.20699 6.05687C7.61704 6.05687 7.13867 5.57786 7.13867 4.98791C7.13867 4.39796 7.61704 3.91895 8.20699 3.91895C8.79759 3.91895 9.27596 4.39796 9.27596 4.98791Z",
    fill: "#106C3A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1236 4.98791C13.1236 5.57786 12.6452 6.05687 12.0547 6.05687C11.4647 6.05687 10.9863 5.57786 10.9863 4.98791C10.9863 4.39796 11.4647 3.91895 12.0547 3.91895C12.6452 3.91895 13.1236 4.39796 13.1236 4.98791Z",
    fill: "#106C3A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0019 19.191C35.2562 19.191 34.5381 19.4166 34.0317 19.7242L18.2937 29.3535H53.7088L37.9708 19.7242C37.4645 19.4166 36.747 19.191 36.0019 19.191ZM18.8635 30.6653C17.8102 30.6653 17.1943 30.2737 17.0343 29.7058C16.8389 29.0079 17.5157 28.3731 18.1178 28.0071L33.4052 18.6749C34.1063 18.2479 35.0285 18 36.0011 18C36.9731 18 37.8946 18.2289 38.5944 18.6552L53.8831 27.9586C54.4852 28.3245 55.162 29.0099 54.9653 29.7077C54.8065 30.2757 54.1914 30.6653 53.1361 30.6653H18.8635Z",
    fill: "#106C3A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3118 43.4717C20.9799 43.4717 20.6553 43.2022 20.6553 42.871V32.3635C20.6553 32.0323 20.9799 31.7627 21.3118 31.7627C21.643 31.7627 21.967 32.0323 21.967 32.3635V42.871C21.967 43.2022 21.643 43.4717 21.3118 43.4717Z",
    fill: "#106C3A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2467 43.4717C24.9155 43.4717 24.5908 43.2022 24.5908 42.871V32.3635C24.5908 32.0323 24.9155 31.7627 25.2467 31.7627C25.5785 31.7627 25.9025 32.0323 25.9025 32.3635V42.871C25.9025 43.2022 25.5785 43.4717 25.2467 43.4717Z",
    fill: "#106C3A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.773 43.3242C33.4412 43.3242 33.1172 43.0546 33.1172 42.7234V32.452C33.1172 32.1201 33.4412 31.8506 33.773 31.8506C34.1049 31.8506 34.4289 32.1201 34.4289 32.452V42.7234C34.4289 43.0546 34.1049 43.3242 33.773 43.3242Z",
    fill: "#106C3A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.707 43.3242C37.3758 43.3242 37.0518 43.0546 37.0518 42.7234V32.452C37.0518 32.1201 37.3758 31.8506 37.707 31.8506C38.0388 31.8506 38.3635 32.1201 38.3635 32.452V42.7234C38.3635 43.0546 38.0388 43.3242 37.707 43.3242Z",
    fill: "#106C3A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8899 43.4124C46.558 43.4124 46.2334 43.1428 46.2334 42.811V32.5402C46.2334 32.209 46.558 31.9395 46.8899 31.9395C47.2211 31.9395 47.5451 32.209 47.5451 32.5402V42.811C47.5451 43.1428 47.2211 43.4124 46.8899 43.4124Z",
    fill: "#106C3A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8248 43.4124C50.4936 43.4124 50.1689 43.1428 50.1689 42.811V32.5402C50.1689 32.209 50.4936 31.9395 50.8248 31.9395C51.1567 31.9395 51.4807 32.209 51.4807 32.5402V42.811C51.4807 43.1428 51.1567 43.4124 50.8248 43.4124Z",
    fill: "#106C3A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1978 46.406C20.8659 46.406 20.5957 46.082 20.5957 45.7508C20.5957 45.4189 20.8659 45.0942 21.1978 45.0942H50.8039C51.1351 45.0942 51.4053 45.4189 51.4053 45.7508C51.4053 46.082 51.1351 46.406 50.8039 46.406H21.1978Z",
    fill: "#106C3A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0578 50.341C17.7266 50.341 17.457 50.017 17.457 49.6858C17.457 49.3539 17.7266 49.0293 18.0578 49.0293H53.9458C54.277 49.0293 54.5465 49.3539 54.5465 49.6858C54.5465 50.017 54.277 50.341 53.9458 50.341H18.0578Z",
    fill: "#106C3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineBank);
export default __webpack_public_path__ + "static/media/online-bank.0584cd79fc52cdc5a5b25797f766affa.svg";
export { ForwardRef as ReactComponent };